export default __webpack_public_path__ + "static/media/about_us.bd4dff9b.jpg";